import Vue from "vue";
import App from "@/components/App.vue";
import MessageBox from "@/components/MessageBox";
import router from "@/router";
import store from "@/store";

import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.compact.css";
import "@/components/layout/ed-grid.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

Vue.prototype.$msg = MessageBox;

import "@/components";
import "@/api";

Vue.prototype.$msg = MessageBox;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
